import UserData from "../interfaces/models/userData";

export function createEmptyUser(uid: string) {
  const emptyUser: UserData = {} as any;
  emptyUser.firstname = "";
  emptyUser.lastname = "";
  emptyUser.registrationFlags = {} as any;
  emptyUser.registrationFlags.AVATAR = false;
  emptyUser.registrationFlags.DAILY_LIMITS_CALCULATED = false;
  emptyUser.registrationFlags.DATA_SECURITY = false;
  emptyUser.registrationFlags.PERSONALIZE = false;
  emptyUser.registrationFlags.REGISTRATION_COMPLETED_INFO = false;
  emptyUser.registrationFlags.TABACCO = false;
  emptyUser.registrationFlags.USERNAME = true;
  emptyUser.registrationFlags.REGISTRATION_ONBOARDING_COMPLETED = false;
  emptyUser.supporterMode = true;
  emptyUser.$uid = uid;
  return emptyUser;
}



// WEBPACK FOOTER //
// ./src/functions/createUser.tsx